import { ICartItemProperties } from "../../../Interfaces/Cart";
import { formatMoneyIntl } from "../../../Utils/Money";

export const additionalCartItemProperties = (activeChoices: HTMLElement[]): { [key: string]: ICartItemProperties } => {
    return activeChoices.reduce((acc, cur) => {
        if (cur.dataset.additionalProperties) {
            let properties;
            try {
                properties = JSON.parse(cur.dataset.additionalProperties);
            } catch (error) {
                properties = {};
            }
            return { ...acc, ...{ [cur.dataset.choice]: properties } };
        }
        return acc;
    }, {});
};
export const regTax = new RegExp("javascript:calculateTax");
export const calculateTax = (choice: HTMLElement, price: number): string => {
    const taxRate = parseFloat(choice.dataset.taxRate);
    return formatMoneyIntl((price / 100) * taxRate).replace(/\s/, " "); /* replace &nbsp; added by number formatter */
};
